module.exports = __webpack_public_path__ + "img/medal5.6a8d68ef.png";